import { Invoice } from '@accounting/interfaces/invoice';
import Vue from 'vue';

import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import ModulesHelper from '@core/services/modules.helper';

library.add(faPlus);
library.add(faIdCard);
library.add(faBook);

@Component({
  name: 'bpc-invoice-tabs',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class InvoiceTabs extends Vue {
  /*   @Prop({ type: String, required: true }) readonly dashboardRoute: string;
   */

  public mounted() {
    this.$store.dispatch('invoiceCounts/getInvoicesCount');
  }
  get invoicesInDraft() {
    return this.$store.getters['invoiceCounts/invoicesInDraft'];
  }
  get invoicesInToPay() {
    return this.$store.getters['invoiceCounts/invoicesInTopay'];
  }
  get accountingIntegrationsModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(
      ModulesHelper.ACCOUNTING_INTEGRATIONS_MODULE_NAME,
    );
  }
}
